import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DenialCodeComponent } from './denial-code.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [DenialCodeComponent],
  exports: [DenialCodeComponent]
})
export class DenialCodeModule { }



// WEBPACK FOOTER //
// ./src/app/utils/denial-code/denial-code.module.ts